// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.agreement{\n    margin-top: 64px;\n}\n.content {\n    background: #fff;\n    border: 1px solid #cdcdcd;\n    padding: 18px;\n    margin-left: 42px;\n    margin-top: 30px;\n}\n.line{\n  margin-top: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
